import { normalizeArray } from "./arrays";

// External commerce sources (commercetools / SFCC) return absolute image URLs
// already; JCR returns paths relative to the Magnolia host that need the base
// prefix. Detect absolute and pass through unchanged.
const isAbsoluteUrl = (link) => typeof link === "string" && /^(https?:)?\/\//i.test(link);
const composeImageLink = (link) => (isAbsoluteUrl(link) ? link : process.env.REACT_APP_MAGNOLIA_BASE_URL + link);

export const getImagesLink = (imageNode, renditions) => {
    const renditionsArr = normalizeArray(renditions);
    const links = {};

    for (const rendition of renditionsArr) {
        const link = getImageLink(imageNode, rendition);

        if (link) links[rendition] = link;
    }

    return links;
};

export const getImageLink = (imageNode, rendition = null) => {
    if (!imageNode) return null;
    if (!rendition) return composeImageLink(imageNode["@link"]);

    if (!imageNode.renditions || !imageNode.renditions[rendition]) return null;

    return composeImageLink(imageNode.renditions[rendition].link);
};

export const getImageAltText = (imageNode) => {
    if (!imageNode) return "";
    // JCR images carry a `metadata` sub-object with title/caption; external
    // commerce images don't — fall back to the image's @name or an empty string
    // so the React img tag still renders.
    const metadata = imageNode.metadata || {};
    return metadata.title || metadata.caption || imageNode["@name"] || "";
};
